import type { ReactNode } from "react"
import TextAtm from "@onestore/hel/dist/components/atoms/TextAtm"
import FlexContainerOrg from "@onestore/hel/dist/components/organisms/FlexContainerOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import _t from "@core/i18n"
import { block300, search } from "@ionos-web-design-system/icon/system"
import { DomainSearchBar, Icon } from "@ionos-web-design-system/react"
import useHelThemeData from "~/hooks/useHelThemeData"
import UdsThemeProvider from "../UdsThemeProvider"

export type DomainInputFieldProps = {
  value?: string
  loading?: boolean
  onChange: (value: string) => void
  onSearch: () => void
  errorMessage?: string
  hasMonochromeUdsButtonConcept?: boolean
  hasNoTextOnButton?: boolean
  inputWrapperId?: string
  suffix?: ReactNode
  placeholder?: string
}

export default function SingleLineDomainSearchBar({
  value,
  loading,
  onChange,
  onSearch,
  errorMessage,
  hasMonochromeUdsButtonConcept = false,
  hasNoTextOnButton = false,
  inputWrapperId,
  suffix,
  placeholder,
}: DomainInputFieldProps) {
  const { isDarkOnColorValue } = useHelThemeData()

  return (
    <>
      <DomainSearchBar
        variant="single-line"
        id={inputWrapperId}
        value={value}
        placeholder={placeholder ?? _t("domainSearch.placeholder")}
        onChange={onChange}
        onSearch={onSearch}
        loading={loading}
        suffix={suffix}
        buttons={[
          {
            text: hasNoTextOnButton
              ? ""
              : _t("domainSearch.domainInput.submit"),
            variant: "primary",
            concept: hasMonochromeUdsButtonConcept ? "monochrome" : "brand",
            icon: search,
            iconOnly: hasNoTextOnButton,
            ariaLabel: _t("domainSearch.domainInput.submit"),
          },
        ]}
        responsiveButton
        data-test-id="domain-search-box"
      />

      {errorMessage ? (
        <UdsThemeProvider>
          <PushOrg topSpace={2} hasNoReset>
            <TextAtm color={isDarkOnColorValue ? "errorLight" : "error"}>
              <FlexContainerOrg alignItems="center" gapSpace={2}>
                <Icon icon={block300} />
                {errorMessage}
              </FlexContainerOrg>
            </TextAtm>
          </PushOrg>
        </UdsThemeProvider>
      ) : null}
    </>
  )
}
